<template>
  <el-container>
    <el-header>
      <img src="../assets/images/logo.svg" style="width: 123px; height: 34px" />
      <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
        <el-menu-item index="/index">首页</el-menu-item>
        <el-menu-item index="/cscp">财税产品</el-menu-item>
        <el-menu-item index="/cpcp">财评产品</el-menu-item>
        <!-- <el-menu-item index="/csal">财税案例</el-menu-item> -->
        <el-menu-item index="/khal">客户案例</el-menu-item>
        <el-menu-item index="/gywm">关于我们</el-menu-item>
        <el-menu-item index="/lxwm">联系我们</el-menu-item>
      </el-menu>
    </el-header>

    <el-main id="scrTop">
      <router-view />
    </el-main>
    <el-backtop target=".el-main" style="width:50px;height:50px" :bottom="50">
      <el-image fit="cover" :src="toTopImg" style="width:40px;height:40px"></el-image>
    </el-backtop>
  </el-container>
</template>

<script>
export default {
  name: "v-home",
  data() {
    return {
      activeIndex: "1",
      toTopImg: require('../assets/images/totop1.png')
    };
  },
  mounted() { },
  updated() {
    let scrTop = document.getElementById("scrTop");
    scrTop.scrollTop = 0;
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped ></style>



// WEBPACK FOOTER //
// src/views/home.vue